const translations = {
    canceled: 'Canceled'
};

export default translations;
